export const OFFER_CONDITION = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DISCARDED: 'DISCARDED',
  EXPIRED: 'EXPIRED',
};
